import React from "react";
import { SimpleImg } from 'react-simple-img';

export const Logo = props => {
  return (
      <div className="left-icon">
        <SimpleImg  height={28} src="https://www.elifeamerica.com/ecommerce-app/fabric/fabric-logo.png" alt="diamond" placeholder="#11204E" />
      </div>
      
  );
};
